import { useFieldArray } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';
import { Plus, TrashBin } from '@gravity-ui/icons';
import { Button, TextInput } from '@gravity-ui/uikit';
import { useEffect } from 'react';

import styles from './styles.module.scss';

interface ShortTermGoalsProps {
	index: number;
	control: any;
	register: any;
	errors: any;
}

export const ShortTermGoals = ({ index, control, register, errors }: ShortTermGoalsProps) => {
	const { fields, append, remove } = useFieldArray({
		control,
		name: `problems.${index}.shortTermGoals`,
	});

	useEffect(() => {
		if (fields.length === 0) {
			append({ text: '' });
		}
	}, [fields.length, append]);

	const addGoal = () => {
		if (fields.length < 3) {
			append({ text: '' });
		}
	};

	const removeGoal = (goalIndex: number) => {
		if (fields.length > 1) {
			remove(goalIndex);
		}
	};

	return (
		<FormRow label="Краткосрочная цель" className={`${styles.row} ${styles.shortTermGoal}`}>
			<div className={styles.shortTermGoals}>
				{fields.map((field, goalIndex) => (
					<div key={field.id} className={styles.shortTermGoals__item}>
						<div className={styles.shortTermGoals__input}>
							<TextInput
								{...register(`problems.${index}.shortTermGoals.${goalIndex}.goal`)}
								placeholder={`Цель ${goalIndex + 1}`}
								validationState={
									errors?.problems?.[index]?.shortTermGoals?.[goalIndex]?.goal ? 'invalid' : undefined
								}
								errorMessage={errors?.problems?.[index]?.shortTermGoals?.[goalIndex]?.goal?.message}
								size="l"
							/>
						</div>
						{fields.length > 1 && (
							<Button
								onClick={() => removeGoal(goalIndex)}
								view="flat"
								size="l"
								className={styles.shortTermGoals__removeBtn}
							>
								<TrashBin />
							</Button>
						)}
					</div>
				))}

				{fields.length < 3 && (
					<div className={styles.shortTermGoals__addButton}>
						<Button onClick={addGoal} view="outlined" size="l" className={styles.shortTermGoals__addBtn}>
							<Plus /> Добавить цель
						</Button>
					</div>
				)}
			</div>
		</FormRow>
	);
};
